const EXAM_STATUS = {
  NEW: { key: 'NEW', name: 'Novo' },
  APP: { key: 'APP', name: 'Aprovado' },
  REV: { key: 'REV', name: 'Revisado' },
  INC: { key: 'INC', name: 'Inconclusivo' },
  PRO: { key: 'PRO', name: 'Processando' },
  ERR: { key: 'ERR', name: 'Não processado' },
};

export default EXAM_STATUS;
